import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Nav from "./Nav";
import { fetchBillFullReport, deleteBillApi } from "./api";

const Billreport = () => {
  const queryClient = useQueryClient();

  const MyDate = new Date();
  const MyDateString =
    MyDate.getFullYear() +
    "-" +
    ("0" + (MyDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + MyDate.getDate()).slice(-2);

  const [date, setDate] = useState(MyDateString);
  const [date1, setDate1] = useState(MyDateString);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch single date report
  const {
    data: reportData = { value: [], total: 0, count: 0 },
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["billreport", date, date1],
    queryFn: () => fetchBillFullReport(date, date1),
  });

  // Delete mutation
  const deleteMutation = useMutation({
    mutationFn: deleteBillApi,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["billreport", date, date1] }),
  });

  // Filtered data based on search input
  const filteredData = reportData.value.filter((k) => {
    const q = searchQuery.toLowerCase();
    return [k[3], k[4] ?? "", k[5] ?? ""].some((field) =>
      field.toLowerCase().includes(q)
    );
  });

  return (
    <>
      <Nav />
      <div className="container-fluid my-5 p-4 rounded shadow bg-light">
        <h2 className="text-center text-primary fw-bold mb-4">
          Bill Report 📜
        </h2>

        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <input
              type="date"
              value={date1}
              onChange={(e) => setDate1(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <button
              onClick={refetch}
              className="btn btn-success w-100 shadow-sm"
            >
              Filter Date 📅
            </button>
          </div>
        </div>

        <input
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="form-control mb-4"
          placeholder="🔍 Search by name, mobile, or area..."
        />

        {window.localStorage.getItem("pro") === "salman" ? (
          <h5 className="text-success">
            💰 Total: <b>{reportData.total}</b> &nbsp;&nbsp; 📦 Count:{" "}
            <b>{reportData.count}</b>
          </h5>
        ) : (
          <h5 className="text-success">
            📦 Count: <b>{reportData.count}</b>
          </h5>
        )}

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-responsive mt-3">
            <table className="table table-striped table-hover align-middle">
              <thead className="table-primary">
                <tr>
                  <th>Cid</th>
                  <th>Sid</th>
                  <th>Name</th>
                  <th>Area</th>
                  <th>Mobile no</th>
                  <th>Pname</th>
                  <th>Price</th>
                  <th>Balance</th>
                  <th>Paid</th>
                  <th>Paid Date</th>
                  {window.localStorage.getItem("pro") === "salman" && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((d) => (
                    <tr key={d[0]}>
                      <td>{d[1]}</td>
                      <td>{d[2]}</td>
                      <td>{d[3]}</td>
                      <td>{d[4]}</td>
                      <td>{d[5]}</td>
                      <td>{d[6]}</td>
                      <td className="text-success fw-bold">{d[7]}</td>
                      <td className="text-danger fw-bold">{d[8]}</td>
                      <td>{d[9]}</td>
                      <td>{d[10]}</td>
                      {window.localStorage.getItem("pro") === "salman" && (
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => deleteMutation.mutate(d)}
                            disabled={deleteMutation.isLoading}
                          >
                            {deleteMutation.isLoading
                              ? "Deleting..."
                              : "❌ Delete"}
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center text-muted">
                      No data found 🚫
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Billreport;
